export const normalizeFormVersion = (value) => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const resolvePlanningFormVersion = (payloadVersion, recordVersion, defaultVersion) => {
  const normalizedRecordVersion = normalizeFormVersion(recordVersion);
  if (normalizedRecordVersion !== undefined) {
    return normalizedRecordVersion;
  }

  const normalizedPayloadVersion = normalizeFormVersion(payloadVersion);
  if (normalizedPayloadVersion !== undefined) {
    return normalizedPayloadVersion;
  }

  const normalizedDefaultVersion = normalizeFormVersion(defaultVersion);
  if (normalizedDefaultVersion !== undefined) {
    return normalizedDefaultVersion;
  }

  return 0;
};
